import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const WarningIcon = React.forwardRef(({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }, ref) => {
  return (
    <svg ref={ref} style={{ ...style, ...overrideStyles }} {...iconSizes[size]} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <g clipPath="url(#clip0)">
        <path d="M98.2676 78.2647L58.9585 10.1798C57.1133 6.9856 53.6762 5 49.987 5C46.2978 5 42.8607 6.98445 41.0144 10.1798L1.38287 78.823C-0.461149 82.0172 -0.461149 85.9873 1.38402 89.1827C3.22919 92.3769 6.6663 94.3625 10.3555 94.3625H89.5724C89.5908 94.3625 89.615 94.3625 89.6334 94.3625C89.6461 94.3625 89.6576 94.3625 89.6691 94.3625C95.3681 94.3464 100 89.7053 100 84.0028C99.9988 81.9482 99.4003 79.966 98.2676 78.2647ZM89.6392 89.7582C89.6334 89.7582 89.6265 89.7582 89.6208 89.7582H10.3555C8.30658 89.7582 6.39695 88.6555 5.37134 86.8805C4.34574 85.1056 4.34574 82.9001 5.37134 81.1251L45.0017 12.482C46.0284 10.707 47.9381 9.6043 49.987 9.6043C52.0359 9.6043 53.9455 10.707 54.9711 12.482L94.3194 80.6348C94.3471 80.6831 94.3782 80.7303 94.4081 80.7764C95.055 81.7283 95.3957 82.8437 95.3957 84.0028C95.3945 87.1763 92.8127 89.7582 89.6392 89.7582Z" fill={color} />
        <path fillRule="evenodd" clipRule="evenodd" d="M46 67L46 29L54 29L54 67L46 67Z" fill={color} />
        <path fillRule="evenodd" clipRule="evenodd" d="M46 81L46 73L54 73L54 81L46 81Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="100" height="100" fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
});

WarningIcon.displayName = 'WarningIcon';

export default WarningIcon;
